'use strict';
import PickerCtrl from './mx-picker.controller';
import template from './mx-picker.html';
import { commonPickerProperties } from './mx-picker-properties';
import './mx-clear-picker-btn';
import './mx-sglclick';

angular.module('mx.components').directive('mxPicker', mxPickerComponent);

mxPickerComponent.$inject = ['$mdConstant'];
export default function mxPickerComponent($mdConstant) {
	var directive = new mx.components.FormControlBase(PickerCtrl, null, template);

	angular.extend(directive.bindToController, commonPickerProperties);

	directive.bindToController.selectedItem = '=?';

	var originalLink = directive.link;
	directive.link = function link(scope, element) {
		originalLink.apply(this, arguments);

		element.on('keydown', onKeyDown);
		element.on('focusin', onFocusOut);

		element.on('$destroy', cleanUp);
		scope.$on('$destroy', cleanUp);

		function onKeyDown(e) {
			var isCtrlPressed = e.ctrlKey;
			var isXPressed = e.which === 88;
			var isVPressed = e.which === 86;
			var isTabPressed = e.which === $mdConstant.KEY_CODE.TAB;
			var isDeletePressed = e.which === $mdConstant.KEY_CODE.DELETE;
			var isBackspacePressed = e.which === $mdConstant.KEY_CODE.BACKSPACE;
			var isMovementKeyPressed =
				e.which === $mdConstant.KEY_CODE.UP_ARROW ||
				e.which === $mdConstant.KEY_CODE.DOWN_ARROW ||
				e.which === $mdConstant.KEY_CODE.LEFT_ARROW ||
				e.which === $mdConstant.KEY_CODE.RIGHT_ARROW ||
				e.which === $mdConstant.KEY_CODE.HOME ||
				e.which === $mdConstant.KEY_CODE.END;

			if (scope.vm.readOnly) {
				if (isDeletePressed || isBackspacePressed || isXPressed || isVPressed) {
					e.preventDefault();
				}

				if (!isCtrlPressed && !isTabPressed && !isMovementKeyPressed) {
					e.preventDefault();
				}
			}

			element.addClass('mx-picker--touched');
		}

		function onFocusOut() {
			var input = element.find('input');

			if (!input.val().trim()) {
				input.val('');
			}
		}

		function cleanUp() {
			element.off();
		}
	};

	return directive;
}
